import en from './en-US';
import de from './de-DE';
import fr from './fr-CA';
import trTR from './tr-TR';
import ruRU from './ru-RU';
export default {
	...en,
	...de,
	...fr,
	...trTR,
	...ruRU,
}